<template>
<div id="start" class="hidden-scroll">
    <div class="notive_wrap" autocomplete="new-password">
        <div style="position: absolute;left:-999px;">
            <input type="text" id="tricUser_hp" name="tricUser_hp" autocomplete="off"  placeholder="입력하세요.">
            <input type="password" id="tricPwd" name="tricPwd"  autocomplete="off" placeholder="입력하세요.">
            <input type="password" id="tricPwd1" name="tricPwd1"  autocomplete="off" placeholder="입력하세요.">
        </div>
    </div>
    <div class="start_bg">
        <div class="storeWrap">
            <div class="main-content-wrap">
                <p class="storetit">매장선택</p>
                <div class="storeselect" >
                    <ul>
                        <li class="fixedd" :class="{ 'on' : isStoreSelState(item.store_id) }" v-for="(item, index) in store_list" :key="index" @click="select_store(item)">
                            <div v-if="item.store_name.length < 18">{{item.store_name}}</div>
                            <div v-else>{{item.store_name.substring(0, 18)}}..</div>
                            <div class="check"></div>
                            <!-- <div class="check"><img src="../../assets/image/select.png"></div> -->
                        </li>
                    </ul>
                </div>
                <div class="storenotice">
                    <p><input class="storecheck" id="box1" v-model="store_check" type="checkbox"><label class="storelabel" for="box1"></label><label for="box1">기본 매장 설정</label></p>
                </div>
            </div>
            <div class="storebtn">
                <div class="btn-cancel" @click="go_back">취소</div>
                <div class="btn-ok" @click="go_store">확인</div>
            </div>            
        </div>
    </div>

    <!-- <modals-container /> -->
</div>
</template>

<script>

import vue from 'vue';
// import external from '@/assets/js/external.js';

// 사용자 정의 모듈.
import * as config from '../../javascript/config';
import main from './main'

export default {
    name: 'start',
    data() {
        return {
            store_list: [],
            sel_store_id: '',
            sel_user_id: '',
            sel_store_tag_check: false,
            store_check: false
        }
    },
    methods: {
        go_back(){
            this.$router.push('/');
        },
        go_store(e){
            if(this.sel_store_id !== ''){
                if(this.store_check){
                    for(let data of this.store_list){
                        data.m_default_store_yn = 0;
                        if(data.store_id === parseInt(this.sel_store_id)){
                            data.m_default_store_yn = 1;
                        }
                    }
                    this.$store.commit('set_store_list', {
                        store_list: this.store_list
                    });
                }

                this.$store.commit('change_login_chk', {
                    value: false
                });

                // kiosk 단말 인증
                const type = config.REQ_MOBILE_SIGN_IN;
                const data = {
                    data: {
                        store_id: this.sel_store_id,
                        user_id : this.sel_user_id,
                        user_hp : this.$store.getters['getUser'].user_hp,
                        store_check : this.store_check
                    }
                }; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}               
                this.$store.dispatch(config.ACT_SERVER_REQUEST_ASYNC, {
                    type: type,
                    data: data
                    // }).then(function (response) { // => this.$store를 인식하지 못하는 문제로 아래 코드 사용.
                }).then((response) => {
                    if (response.result) {
                        this.$store.commit('set_user', {
                            user: response.user
                        });

                        this.$store.commit('change_store_check', {
                            user_id: response.user.user_id
                        });

                        // 정상 로그인
                        this.$store.commit('set_store_info', {
                            store_info: response.data
                        });
                        this.$store.commit('change_main_start_chk', {
                            value: true
                        });
                        this.$store.commit('change_login_chk', {
                            value: true
                        });
                        
                        // 기초 데이터 요청
                        return this.$store.dispatch(config.ACT_GET_INIT_DATA);
                    } 
                }).then((response) => {
                    // this.set_token();
                    this.$store.commit('change_main_start_chk', {
                        value: true
                    });
                    this.$store.commit('set_page_header_init', {
                        style: 'block'
                    });  

                    this.$router.push('/front_main');
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }else{
                const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                message: `매장을 선택해주세요.`,
                router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                // alert('입력란 공백 체크');
                return;
            }
            
        },
        select_store(item){
            this.sel_store_id = item.store_id;
            this.sel_user_id = item.user_id;           
            let li_class = document.getElementsByClassName('fixedd');
            for(let i=0; i<li_class.length; i++){
                li_class[i].classList.remove('on');
            }           
        },
        isStoreSelState(id) {
            if(id === parseInt(this.sel_store_id)) return true;
            else false;
        }
    },
    mounted() {
        this.$nextTick(function () {
            let user_hp = this.$store.getters['getUser'].user_hp;

            this.store_list = this.$store.getters['getStoreList'];

            let sotre_arr = [];
            this.store_list.forEach(item => {
                sotre_arr.push(item.m_default_store_yn)
            })
            if(sotre_arr.includes(1)) this.store_check = true;

            //  this.sel_store_id = this.store_list[0].store_id;
            this.sel_user_id = this.store_list[0].user_id;
            if(this.store_check) this.sel_store_id = this.$store.getters['getUser'].store_id;
            else this.sel_store_id = this.store_list[0].store_id;


        });
    },
    watch: {
    }
}
</script>




// WEBPACK FOOTER //
// src/components/page/store.vue